import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { handleError } from 'services/Error';
import { usePostSendEReferralMutation } from 'store/api/xComApi';

const Title = 'Send E-Referral';

const ReasonOptions = ["Didn't Receive E-Referral", 'Last E-Referral Failed'];

export const SendEReferralDialog = ({
    isOpen,
    onClose,
    referralDetails = undefined,
    supplierDetails = undefined,
}) => {
    const [sendEReferral] = usePostSendEReferralMutation();
    const { organizationName: supplierName } = supplierDetails ?? {};

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={Yup.object({
                ...ReasonInput.validationSchema,
            })}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await sendEReferral({
                        payerId: referralDetails.payerId,
                        treatmentId: referralDetails.treatmentId,
                        referralId: referralDetails.referralId,
                        reason: values.reason,
                        source: values.source,
                    }).unwrap();
                    SuccessToast({
                        message: 'E-Referral sent successfully.',
                    });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to send E-Referral. Please try again.', err);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen={isOpen}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Send E-Referral"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action will send an e-referral with authorization details for
                                this referral.
                            </div>
                            <div className="margin__bottom--medium" style={{ display: 'flex' }}>
                                <DetailLabelValuePair
                                    className="margin__right--x-large"
                                    label="Name"
                                    value={supplierName}
                                />
                            </div>
                            <ReasonInput reasons={ReasonOptions} />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

SendEReferralDialog.Title = Title;

SendEReferralDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    referralDetails: PropTypes.shape({
        referralId: PropTypes.string.isRequired,
        payerId: PropTypes.string.isRequired,
        treatmentId: PropTypes.string.isRequired,
    }),
    supplierDetails: PropTypes.shape({
        organizationName: PropTypes.string,
    }),
};
